import React, { useState, useEffect, useRef } from 'react';

import { useTimer } from '../../context/TimerContext';

import { usePageControl } from '../../context/PageControlContext';
import PageNavigation from '../../components/PageNavigation';

import Popup from '../../components/Popup';
import { usePopupVideoAutoClose } from "../../hooks/usePopupVideoAutoClose";

function Module7() {

  // Page nav control
  const { canGoBack, setCanGoBack } = usePageControl();
  const { canContinue, setCanContinue } = usePageControl();

  useEffect(() => {
    setCanGoBack(false);
  }, [setCanGoBack]);
  
  useEffect(() => {
    setCanContinue(true);
  }, [setCanContinue]);
  
  // Popup
  const [showPopup, setShowPopup] = useState(false);

  // - Time-based popup after page load
  const showAfterSeconds = 2; // Seconds

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, showAfterSeconds * 1000);

    return () => clearTimeout(timer);
  }, []);

  // - Manual popup trigger using class
  useEffect(() => {
    const triggers = document.querySelectorAll('.popup-trigger');
    triggers.forEach(trigger =>
      trigger.addEventListener('click', () => setShowPopup(true))
    );

    return () => {
      triggers.forEach(trigger =>
        trigger.removeEventListener('click', () => setShowPopup(true))
      );
    };
  }, []);


  // Popup Video Auto Close
  const {
    videoRef,
    handlePlay,
    handlePopupVideoEnded,
    cancelPopupAutoClose
  } = usePopupVideoAutoClose({ showPopup, setShowPopup });


  // Timer
  const { timeRemaining, formatTime, isRunning } = useTimer();

  // Determine additional classes dynamically
  let additionalClasses = '';
    if (isRunning) {
      additionalClasses += ' timer-running';
    }
    if (timeRemaining <= 600 && timeRemaining >= 0) { // 10 mins or less but not negative
      additionalClasses += ' timer-warning';
    }
    if (timeRemaining < 0) { // time exceeded
      additionalClasses += ' timer-exceeded';
    } 


  return (
    <div id="module-7" className="page physical">
        
        <header className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="CER"></div>
                  <div id="line"></div>
                  <div className={`timer-display${additionalClasses}`}>
                    <span className="timer-text">Time remaining <span className="timer-numbers">{formatTime(timeRemaining)}</span></span>
                  </div>
                </div>
            </div>
        </header>
    
        <main className="container-fluid">
            <div className="row">
                <div className="col-12">
                  <div id="box-wrapper-email">

                    <div id="email-client">
                      <div id="email-client-header"><h1 id="email-client-header-title">Email</h1></div>
                      <div id="email-client-body">
                        <div id="email-client-sidebar"><h2 id="email-client-sidebar-title">Inbox</h2></div>
                        <div id="email-client-content">

                          <div className="email">
                            <div className="email-header">
                              From: les.gettam@met.police.uk
                              <div className="email-attachment popup-trigger" style={{ cursor: 'pointer', color: 'blue' }}>Video</div>                         
                            </div>
                            <div className="email-body">
                              <h2 className="email-subject">Subject: Puzzling!</h2>
                              <p>Nicely done! We're in.</p>

                              <p>Right, we'll need her memorable word to get into her email system. Looks like she's used the <strong>crossword</strong> option for her password reminder. I've got the questions here, but I can't find the <strong>crossword</strong>, or the <strong>key</strong>. Why don't you try looking around at the <strong>objects on her desk</strong>?</p>

                              <p>Hopefully, you'll be able to find that crossword and solve it to get access. Seems to be all about staying safe online so if you need any pointers, I'm sure she's left one of our leaflets around somewhere.</p>

                              <p>When you're in, we'll see what we're dealing with.</p>
                              
                              <p>DS Les Gettam</p>
                            </div>
                          </div>

                      </div>
                    </div>

                    </div>
                  </div>

      <Popup
        className="popup-box-video"
        title="DS Les Gettam"
        isOpen={showPopup}
        onClose={() => setShowPopup(false)}
        footer={
        <>
          <button onClick={handlePlay} className={"btn" + " " + "btn-video" + " " + "btn-video-play"}><span className="visually-hidden">Play video</span></button>
          <button onClick={() => setShowPopup(false)} className={"btn" + " " + "btn-video" + " " + "btn-video-close"}><span className="visually-hidden">Close video</span></button>
        </>
        }
      >
      <video
        ref={videoRef}
        controls
        onPlay={cancelPopupAutoClose} // make sure an auto-close timer isn't running on play
        onEnded={() => handlePopupVideoEnded(3)} // auto-close after X seconds when video ends
        controlsList="nodownload nofullscreen noremoteplayback"
        disablePictureInPicture
      >
        <source src={`/videos/offline/video_03_1.mp4`} type="video/mp4" />
        Your browser does not support the video tag.
        <track src={`/videos/offline/video_03_1.vtt`} kind="subtitles" srcLang="en" label="English" default></track>
      </video>
      </Popup>

                </div>
            </div>
        </main>

        <footer className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <PageNavigation />
                </div>
            </div>
        </footer>
    
    </div>
  );
};

export default Module7;
